export default {"pagination1":"o3miZ","btnBlackPagination":"_835j3","itemButton":"_7B-EQ","itemButtonText":"BG5rt","link":"PQnWN","linkPrev":"gTqTm"};